<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i><strong>Synthèse Portefeuille par SIRH</strong>
      </b-card-header>
      <b-card-body>
        <table class="tab_synthese" border="1px">
          <thead>
          <tr>
            <td class="prune-medium p-2"><b>SIRH</b></td>
            <td class="prune-medium right p-2"><b>Nb SIREN</b></td>
            <td class="prune-medium right p-2"><b>Effectif affilié</b></td>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(element, key) in finalResult" :key="key">
            <td class=" p-2">{{ key }}</td>
            <td class="right p-2"><b>{{ element['SIREN'] }}</b></td>
            <td class="right p-2"><b>{{ element['NbSal'] }}</b></td>
          </tr>
          <tr>
            <td class=" p-2">Autres SIRH (Effectif global < 1.000 Sal.)</td>
            <td class=" right p-2">{{ Autre_SIREN }}</td>
            <td class=" right p-2">{{ Autre_NbSal }}</td>
          </tr>
          <tr>
            <td class=" p-2">SIRH non-connu</td>
            <td class=" right p-2">{{ NC_SIREN }}</td>
            <td class=" right p-2">{{ NC_NbSal }}</td>
          </tr>
          <tr>
            <td class="prune-medium p-2"><b>Total Portefeuille</b></td>
            <td class="prune-medium right p-2"><b>{{ totalSiren }}</b></td>
            <td class="prune-medium right p-2"><b>{{ totalNumberSal }}</b></td>
          </tr>
          </tbody>
        </table>
      </b-card-body>
    </b-card>
  </div>

</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "../../../utils/auth";

  export default {
    name: "SyntheseStirh",
    data() {
      return {
        finalResult: [],
        totalSiren: 0,
        totalNumberSal: 0,
        NC_NbSal: 0,
        NC_SIREN: 0,
        Autre_NbSal: 0,
        Autre_SIREN: 0,
      }
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
      //this.downloadSyntheseSirh();
    },
    methods: {
      downloadSyntheseSirh() {
        let self = this;
        this.$store.commit('IS_LOADING', false);
        this.$axios.get('/espaceGestion/extractions/synthese_sirh')
          .then((response) => {
            this.$store.commit('IS_LOADING', false);
            this.finalResult = response.data.data.finalResult;
            this.totalSiren = response.data.data.TotSIREN;
            this.totalNumberSal = response.data.data.TotNbSal;
            this.NC_NbSal = response.data.data.NC_NbSal;
            this.NC_SIREN = response.data.data.NC_SIREN;
            this.Autre_NbSal = response.data.data.Autre_NbSal;
            this.Autre_SIREN = response.data.data.Autre_SIREN;
          })
          .catch(error => {
            self.$store.commit('IS_LOADING', false);
            console.log(error);
          });
      }
    }
  }
</script>

<style scoped>

  .prune-medium {
    background-color: #C0504D;
    color: #FFFFFF;
  }

  .right {
    text-align: right;
  }

</style>

